<template>
  <v-navigation-drawer fixed hide-overlay mobile-break-point="0" disable-resize-watcher :value="printDialogOpened" width="500" >
    <v-toolbar flat extension-height="100">
      <v-toolbar-title>{{ $t('imprimir-ficha') }}</v-toolbar-title>
      <v-toolbar-title slot="extension" style="width: 100%;" class="px-2 ma-0">
        <v-layout row wrap>
          <v-flex xs6 class="px-1">
            <v-btn color="green" block @click="printReport" :disabled="isLoading">
              <v-icon class="px-1">print</v-icon>
              {{ $t('imprimir-ficha') }}
            </v-btn>
          </v-flex>

          <v-spacer></v-spacer>

          <v-flex xs6 class="px-1">
            <v-btn color="red lighten-2" block @click="cleanForm" :disabled="dirty">
              <v-icon class="px-1">refresh</v-icon>
              {{ $t('limpiar-formulario') }}
            </v-btn>
          </v-flex>

        </v-layout>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn :disabled="isLoading" icon @click="printDialogOpened = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 class="px-1">
          <v-text-field
            :disabled="isLoading"
            :label="$t('titulo')"
            v-model="titleExport"
            box
          ></v-text-field>
        </v-flex>

        <v-flex xs12 class="px-1">
          <v-select
            :items="years"
            v-model="yearRefExport"
            :disabled="isLoading"
            :label="$t('seleccionar-año-referencia')"
            single-line
            bottom
            box
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-textarea
            :disabled="isLoading"
            name="input-coment"
            :label="$t('comentarios')"
            v-model="commentsExport"
            box
            multi-line
          ></v-textarea>
        </v-flex>
      </v-layout>

    </v-container>


  </v-navigation-drawer>
</template>

<script>

import printReport from './print-report'

export default {

  props: ['period', 'chart', 'lastFeature', 'legend'],

  data() {
    return {
      PrintReport: printReport.bind(this),
      printDialogOpened: false,
      titleExport: '',
      yearRefExport: '',
      commentsExport: '',
      years: Array.from({length: 20}, (e, idx) => (new Date).getFullYear() - 19 + idx).reverse(),
    }
  },

  methods: {
    cleanForm() {
      this.titleExport = this.yearRefExport = this.commentsExport = ''
    },

    async printReport() {
      const period = this.period,
            title = this.titleExport,
            year = this.yearRefExport,
            comments = this.commentsExport,
            layersLoad = this.layersLoad,
            map = this.map,
            chart = this.chart,
            legend = this.legend

      this.isLoading = true

      this.$parent.fitMapToFeatureExtent(0)

      await this.PrintReport(map, chart, legend, layersLoad, { period, title, year, comments})

      this.isLoading = false
    },
  },

  computed: {
    dirty() {
      return this.titleExport == '' && this.yearRefExport == '' && this.commentsExport == ''
    },

    map() {
      return this.$parent.map
    },

    layersLoad() {
      const { LayerOrto, LayerRaster } = this.$parent
      return [LayerOrto, LayerRaster]
    },

    isLoading: {
      get() {
        return this.$store.getters.isLoading
      },
      set(value) {
        this.$store.dispatch('setLoading', value)
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// PrintReport.vue?037ec7c6